<template>
  <section>
    <div>
      <div class="electric-bike-container">
        <div class="wrapper">
          <div class="intro-container">
            <h1 class="header">Our promise to you</h1>
          </div>
          <div>
            <img
              src="~/assets/images/icons/blue/price-match-promise.svg"
              class="alt price-promise"
              alt="payment promise icon"
            />
          </div>
        </div>
      </div>

      <div class="container">
        <div class="section">
          <div class="section-title">
            Find a cheaper quote for the same cover and we’ll match it. That’s
            the
            <span class="blue">Pedalsure Price Match Promise.</span>
          </div>
          <div class="section-body">
            We’re all looking for the best prices. Saving just a couple of
            pounds a month can make a big difference. That’s why we regularly
            check the price of our insurance against other providers to ensure
            we give you the best possible price we can. It happens though,
            sometimes you’ll find cheaper cover elsewhere.<br /><br />
            Our promise to you is simple. After you take out a policy with us,
            if you find a cheaper quote for the same cover from another provider
            and tell us within 7 days of the date you bought your policy we’ll
            match it. No get-outs, no hidden terms and conditions, just a
            straightforward price match.
          </div>
        </div>
        <div class="divider"></div>
        <div class="section">
          <div class="section-title">How to make a price match request</div>
          <div class="section-body">
            Send an email to us at cservice@pedalsure.com to tell us about it
            within 7 days of the date you bought your policy along with a copy
            of the quote you want us to match. If it’s current and for the same
            cover, we’ll issue you with a new policy for that price.
          </div>
        </div>
        <div class="divider"></div>
        <div class="section">
          <div class="section-title">
            The Important Bits<br />
            <span class="blue">
              Some important additional information about our price promise.
            </span>
          </div>
          <div class="section-body">
            <ul>
              <li>
                <span class="dot">&#8226;</span>
                The cheaper quote must be from an insurance provider which is
                authorised to sell insurance in the UK and must be available to
                be purchased at that price on the day the price match request is
                made.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                The cheaper quote must be offered to you and evidenced in
                writing in a quote confirmation email or link from the other
                insurance provider.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                The cheaper quote must be for cover which is the same as the
                cover provided to you by Pedalsure. We understand this might not
                be precisely like-for-like and that’s okay. We promise to act
                fairly and reasonably when deciding whether it’s the same.
                Obviously the personal details, the bikes and their values and
                any core features of the policies must be the same.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                The cheaper quote cannot be cheaper as a result of any special
                promotions or discounts given to you which are not made
                available to all customers of the other insurance provider.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                We don’t match prices only available via third party websites,
                with voucher codes, or made available by the other insurance
                provider through a short term sales promotion.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                If the cheaper quote is a renewal from your existing insurance
                provider, it must be the original renewal price offered by them,
                excluding any price discounts, offers or negotiated rates
                offered after the original renewal.
              </li>
              <li>
                <span class="dot">&#8226;</span>
                We reserve the right to decline a price match request if we
                suspect any abuse or attempted abuse of the offer, any breach or
                attempted breach of the terms and conditions of Pedalsure.com or
                any activity which in our reasonable opinion constitutes misuse
                or fraudulent activity in relation to the Pedalsure Price Match
                Promise.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
// import Featured from '@/components/homepage/Featured'
// import Thrillingly from '@/components/commuter/Thrillingly'
// import PeaceOfMind from '@/components/ebike/PeaceOfMind'
// import BlogWidget from '@/components/blog-widget/BlogWidget'
import { buildSocialMeta } from '@/helpers/social-meta'

export default {
  name: 'PriceMatchPromise',
  components: {
    // Featured,
    // Thrillingly,
    // PeaceOfMind,
    // BlogWidget,
  },
  data() {
    return {
      page: {
        title: 'Pedalsure Price Match Promise',
        meta_description:
          'Our price match promise to you: find a quote for comparable cycle insurance and we’ll match it.',
      },
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'commuter insurance, road, cycling',
        },
        ...buildSocialMeta({
          title: this.page.title,
          description: this.page.meta_description,
          path: this.$route.path,
          image: '/images/og/price-match-promise-1200x630.png',
          type: 'website',
        }).meta,
      ],
    }
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    handleClick() {
      this.resetQuote()
      this.$modal.show('quick-quote')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>

<style lang="scss" scoped>
.wrapper {
  margin: 0 auto;
  max-width: 800px;
  min-height: 200px;

  @include tablet {
    min-height: 400px;
  }
}

.trust-pilot-image {
  text-align: center;
  margin-bottom: 10px;

  p {
    font-size: 0.8rem;
  }

  @include tablet {
    margin-bottom: 30px;
  }

  img {
    width: 120px;
    height: auto;

    @include tablet {
      width: 160px;
    }
  }
}

.get-quote-bt {
  //width: 200px;
  font-size: 20px;
}

.intro-container {
  padding: 0 15px;

  @include tablet {
    padding: 0;
  }

  .header {
    font-size: 9vw;
    line-height: 10vw;
    max-width: 500px;
    text-align: center;
    color: $ps-primary;
    margin: 0 auto 20px;

    @include tablet {
      font-size: 5.5vw;
      line-height: 6vw;
    }

    @include desktop {
      font-size: 4.2vw;
      line-height: 5vw;
    }
  }

  .image {
    max-width: 36%;
  }
}

.electric-bike-container {
  position: relative;
  padding-bottom: 80px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 50%;
    bottom: 0;
    top: 0;
    z-index: -2;
    background-repeat: no-repeat;
    background-size: 170%;
    background-position-y: bottom !important;

    @include tablet {
      background-size: 140%;
    }

    @include desktop {
      background-size: 100%;
    }
  }

  &:before {
    background-size: 100%;
    background-image: url('~assets/images/illustrations/svg/price-promise-left.svg');
    left: 0;
    background-position: -20px;

    @include desktop {
      background-position: -90px;
      background-size: 80%;
    }
  }

  &:after {
    background-image: url('~assets/images/illustrations/svg/price-promise-right.svg');
    right: 0;
    background-position: -20px;

    @include desktop {
      background-position: 20px;
    }
  }
}

// @include tablet {
//   min-height: 500px;
//   margin: 0;
// }
.price-promise {
  max-width: 200px;
  display: block;
  margin: 0 auto;
}
</style>

<style lang="scss" scoped>
.section {
  padding: 0;
  margin: 20px auto 40px;
  width: 100%;
  max-width: 800px;

  &-title {
    font-family: $family-bold;
    width: 95%;
    text-align: center;
    margin: 0 auto 20px;

    @include tablet {
      width: 55%;
    }
  }

  &-body {
    font-size: 13px;
    padding: 0 10px;

    @include tablet {
      font-size: 15px;
    }

    li {
      margin-bottom: 20px;
    }
  }

  span {
    color: $ps-primary;
  }
}

.divider {
  width: 80%;
  height: 1px;
  margin: 0 auto;
  border-bottom: 1px solid gray;

  @include tablet {
    width: 60%;
  }
}
</style>
